/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_DescriptionInputs */

const en_landing_pricing_description = /** @type {(inputs: Landing_Pricing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buy credits once or subscribe. Credits are spent only when you generate a duet video.`)
};

const zh_landing_pricing_description = /** @type {(inputs: Landing_Pricing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一次性购买积分或按月订阅。只有生成双人视频时才会扣积分。`)
};

/**
* | output |
* | --- |
* | "Buy credits once or subscribe. Credits are spent only when you generate a duet video." |
*
* @param {Landing_Pricing_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_pricing_description = /** @type {((inputs?: Landing_Pricing_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricing_description(inputs)
	return zh_landing_pricing_description(inputs)
});
export { landing_pricing_description as "landing.pricing.description" }